export const AUTH_RESET_2FA_ACCEPT = 'AUTH_RESET_2FA_ACCEPT'
export const AUTH_RESET_2FA_ACCEPT_SUCCESS = 'AUTH_RESET_2FA_ACCEPT_SUCCESS'
export const AUTH_RESET_2FA_ACCEPT_FAILED = 'AUTH_RESET_2FA_ACCEPT_FAILED'
